import { useState, useCallback } from 'react';

/**
 * 折叠列表状态管理 Hook
 * @param {Array} initialList - 初始折叠项列表
 * @returns {Object} 折叠列表操作方法
 */
export const useCollapsibleList = (initialList = []) => {
  const [collList, setCollList] = useState(initialList);

  /**
   * 切换折叠状态
   * @param {string|number} key - 项目标识
   */
  const toggleItem = useCallback((key) => {
    setCollList(prev =>
      prev.includes(key)
        ? prev.filter(k => k !== key)
        : [...prev, key]
    );
  }, []);

  /**
   * 判断项目是否折叠
   * @param {string|number} key - 项目标识
   * @returns {boolean} 是否折叠
   */
  const isCollapsed = useCallback((key) => collList.includes(key), [collList]);

  /**
   * 展开所有项目
   */
  const expandAll = useCallback(() => setCollList([]), []);

  /**
   * 折叠所有项目
   * @param {Array} keys - 所有项目的 key 数组
   */
  const collapseAll = useCallback((keys) => setCollList(keys), []);

  return {
    collList,
    setCollList,
    toggleItem,
    isCollapsed,
    expandAll,
    collapseAll
  };
};

export default useCollapsibleList;
